import dataProvider from '@refinedev/simple-rest';
import apiClient from '@/shared/apiClient';

// DataProvider der gegen FastAPI kommuniziert
// Nutzt apiClient mit JWT-Interceptor für authentifizierte Requests
// apiClient.baseURL ist bereits '/api/v1', daher hier leerer String
// Refine Simple Rest sendet Paginierung als ?_start=0&_end=20
// FastAPI antwortet mit JSON + X-Total-Count Header

export const dataProviderInstance = dataProvider('', apiClient);
